module.exports = __webpack_public_path__ + "img/none-module.bede8a4b.svg";